import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import * as Icon from "react-feather";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
const BookingMobile = ({handlePageChange, currentPage, nextPage, prevPage, count, data, screenWidth, onAccept, onReject }) => {
  const itemsPerPage = 5;
  const { user } = useAuth();
  const { t } = useTranslation();

  function renderStatus(item) {
    if (item.status === 'Pending') {
      return <span className="btn" style={{ backgroundColor: "lightgrey", width: 200, textWrap: "wrap" }}>{t(item.status)}</span>;
    } else if (item.status === 'Approved By Agency' || item.status === 'Approved By Supplier') {
      return <span className="btn" style={{ backgroundColor: "lightgreen", width: 200, textWrap: "wrap" }}>{t(item.status)}</span>;
    } else if (item.status === 'Rejected By Agency' || item.status === 'Rejected By Supplier') {
      return <span className="btn" style={{ backgroundColor: "lightsalmon", width: 200, textWrap: "wrap" }}>{t(item.status)}</span>;
    } else if (item.status === 'Created By Supplier' || item.status === 'Created By Agency') {
      return <span className="btn" style={{ backgroundColor: "lightblue", width: 200, textWrap: "wrap" }}>{t(item.status)}</span>;
    } else {
      return <span className="btn btn-secondary" style={{ width: 200, textWrap: "wrap" }}>{t(item.status)}</span>;
    }
}

  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="rounded text-secondary mb-3 text-dark border">
            <div className="w-100 p-3 rounded-top" style={{ backgroundColor: "#DAF8FD" }}>
              <h5 className="text-dark fw-bolder mb-2">{item.name}</h5>
            </div>
            <div className="bg-white p-3 rounded-bottom">
              {/* Status */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Status")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  {renderStatus(item)}
                </div>
              </div>
              {/* Vendor Name */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Vendor Name")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.supplier_name}</p>
                </div>
              </div>
              {/* Agency Name */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Agency Name")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.agency_name}</p>
                </div>
              </div>
              {/* Employer Name */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Employer Name")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.employer_name}</p>
                </div>
              </div>
              {/* Biodata Name */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Biodata Name")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.name}</p>
                </div>
              </div>
              {/* Agency Note */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Agency Note")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.agency_note || "-"}</p>
                </div>
              </div>
              {/* Supplier Note */}
              <div className="row mb-1">
                <div className="col-4" style={{paddingRight: 5}}>
                  <p style={{fontSize: "0.7rem"}}>{t("Supplier Note")}</p>
                </div>
                <div className="col-1 text-center">
                  <p style={{ fontSize: "0.7rem" }}>:</p>
                </div>
                <div className="col-7">
                  <p style={{fontSize: "0.7rem"}} className="fw-bold">{item.supplier_note || "-"}</p>
                </div>
              </div>
              {/* Action */}
              {(user?.type === "agency" && item.status === "Pending") && (
                <div className="row my-2">
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-greys me-2"
                      data-bs-toggle="modal" 
                      data-bs-target="#book_biodata_dialog" 
                      onClick={() => onAccept && onAccept(item)}
                    >
                      <Icon.CheckCircle size={16} /> {t("Accept")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-greys"
                      data-bs-toggle="modal" 
                      data-bs-target="#book_biodata_dialog" 
                      onClick={() => onReject && onReject(item)}
                    >
                      <Icon.XCircle size={16} /> {t("Decline")}
                    </button>
                  </div>
                </div>
              )}
              {(user?.type === "supplier" && item.status === "Approved By Agency") && (
                <div className="row my-2">
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-greys me-2"
                      data-bs-toggle="modal" 
                      data-bs-target="#book_biodata_dialog" 
                      onClick={() => onAccept && onAccept(item)}
                    >
                      <Icon.CheckCircle size={16} /> {t("Accept")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-greys"
                      data-bs-toggle="modal" 
                      data-bs-target="#book_biodata_dialog" 
                      onClick={() => onReject && onReject(item)}
                    >
                      <Icon.XCircle size={16} /> {t("Decline")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>No Data</p>
        </div>
      )}

            {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  );
};

BookingMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  screenWidth: PropTypes.number.isRequired,
  onAccept: PropTypes.func,
  onReject: PropTypes.func,

  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};

export default BookingMobile;